import React, { useEffect, useState } from 'react';
import { DSSheet } from '../../design-system/primitives';
import { apiService } from '../../services/apiService';
import { formatDay } from './helpers';

// Every signature, kept against the moment it was given.
//
// The full history rather than the latest one: a signature is evidence of what
// somebody agreed to at a point in time, and replacing the record each time
// they sign again throws away exactly the part that matters if it is ever
// questioned. Older rows stay visible and are marked as superseded rather than
// removed.
function SigningHistorySheet({ userId, onClose }) {
  const [history, setHistory] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const request = userId
      ? apiService.getSigningHistoryFor(userId)
      : apiService.getMySigningHistory();

    request
      .then((res) => setHistory(res.data || []))
      .catch(() => setFailed(true));
  }, [userId]);

  return (
    <DSSheet title="Signing history" onClose={onClose}>
      <p className="mm-note" style={{ marginTop: 0 }}>
        Every signature is kept with the date it was given.
      </p>

      {failed && <p className="mm-note">Could not load the signing history.</p>}

      {!failed && history === null && <p className="mm-note">Loading...</p>}

      {!failed && history !== null && history.length === 0 && (
        <p className="mm-note">Nothing signed yet.</p>
      )}

      {!failed && history !== null && history.map((entry, index) => (
        <div className="mm-fact" key={`${entry.documentKey}-${entry.signedAt}-${index}`}>
          <span className="mm-fact__label">
            {entry.label}
            <span style={{ display: 'block', marginTop: '2px', fontSize: '11px' }}>
              Signed {formatDay(entry.signedAt)} as {entry.signature}
            </span>
          </span>
          {entry.isCurrent && (
            <span className="mm-fact__value" style={{ color: 'var(--ds-color-statusSuccessText)' }}>
              Current
            </span>
          )}
        </div>
      ))}
    </DSSheet>
  );
}

export default SigningHistorySheet;
